import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=39968c14&scoped=true&"
import script from "./TagsInput.vue?vue&type=script&lang=ts&"
export * from "./TagsInput.vue?vue&type=script&lang=ts&"
import style0 from "./TagsInput.vue?vue&type=style&index=0&id=39968c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39968c14",
  null
  
)

export default component.exports